import { render, staticRenderFns } from "./QuestionBrowsing.vue?vue&type=template&id=66cc4a2e&scoped=true"
import script from "./QuestionBrowsing.vue?vue&type=script&lang=js"
export * from "./QuestionBrowsing.vue?vue&type=script&lang=js"
import style0 from "./QuestionBrowsing.vue?vue&type=style&index=0&id=66cc4a2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc4a2e",
  null
  
)

export default component.exports